var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, BLACK_700, BLACK_900, BLUE_500, Card, Divider, DynamicSvg, InfoTag, LILAC_200, LILAC_400, Typography, WHITE, getTestId, tokens, useBreakpoint } from '@airtel/air-design-system';
import { Fragment, useCallback, useRef } from 'react';
import { FlatList, Image, Pressable, View } from 'react-native';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { onChildCardImpression } from '../../utils/CommonUtils';
import { ButtonWidget } from '../button-widget';
import { CalloutWidget } from '../callout-widget';
import { HeadingTaskCardTab, SingleTaskCardField } from './components';
import { TEXT_TYPE } from './TaskCardWidgetConstants';
import { getTaskCardWidgetStyles } from './TaskCardWidgetStyles';
export var TaskCardWidgetComponent = props => {
  var _props$detailsTaskCar = props.detailsTaskCardList,
    detailsTaskCardList = _props$detailsTaskCar === void 0 ? [] : _props$detailsTaskCar,
    style = props.style,
    onUserAction = props.onUserAction,
    testID = props.testID,
    outerContainerStyle = props.outerContainerStyle,
    singleCardStyle = props.singleCardStyle,
    flatListStyle = props.flatListStyle,
    id = props.id,
    widgetCtaAccessibilityProps = props.widgetCtaAccessibilityProps,
    restProps = __rest(props, ["detailsTaskCardList", "style", "onUserAction", "testID", "outerContainerStyle", "singleCardStyle", "flatListStyle", "id", "widgetCtaAccessibilityProps"]);
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var TaskWidgetStyles = getTaskCardWidgetStyles(isSmallScreen);
  var rowButtonsWidgetProps = props === null || props === void 0 ? void 0 : props.rowButtonsWidgetProps;
  var profileFooter = props === null || props === void 0 ? void 0 : props.profileFooter;
  var setOfVisitedIds = useRef(new Set());
  var renderDescriptionRow = (singleTaskCardDetails, index) => {
    return !!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.descriptionText) && _jsx(View, Object.assign({
      style: TaskWidgetStyles === null || TaskWidgetStyles === void 0 ? void 0 : TaskWidgetStyles.headerWrapper
    }, {
      children: _jsx(View, Object.assign({
        style: TaskWidgetStyles.headerTextWrapper
      }, {
        children: _jsx(Typography, Object.assign({
          type: isSmallScreen ? TEXT_TYPE.BODY_PARA_SM : TEXT_TYPE.BODY_PARA_MD,
          color: BLACK_700,
          isHyperLink: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.isDescriptionTextClickable,
          onPress: event => {
            (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.descriptionTextOnPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.descriptionTextOnPressMetaData), {
              event
            }), props));
          },
          text: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.descriptionText
        }, getTestId(testID, "detailsTaskCardList_" + index.toString() + "_descriptionText")))
      }))
    }));
  };
  var renderTopInfoTag = data => {
    var _a, _b;
    if (!data) return null;
    return _jsx(InfoTag, {
      style: {
        marginTop: tokens.spacing.SPACING_4
      },
      size: isSmallScreen ? 'sm' : 'md',
      type: "inline",
      subType: (_a = data === null || data === void 0 ? void 0 : data.subType) !== null && _a !== void 0 ? _a : 'default',
      text: data === null || data === void 0 ? void 0 : data.tagName,
      theme: (_b = data === null || data === void 0 ? void 0 : data.theme) !== null && _b !== void 0 ? _b : 'light',
      iconName: data === null || data === void 0 ? void 0 : data.iconName
    });
  };
  var renderProfileContainer = data => {
    var _a, _b;
    return _jsxs(View, Object.assign({
      style: TaskWidgetStyles.profileContainer
    }, {
      children: [!!(data === null || data === void 0 ? void 0 : data.profileImageUrl) && !!(data === null || data === void 0 ? void 0 : data.status) && _jsx(Image, Object.assign({}, getTestId(testID, 'imageUrl'), {
        source: {
          uri: data === null || data === void 0 ? void 0 : data.profileImageUrl,
          width: (_a = data === null || data === void 0 ? void 0 : data.width) !== null && _a !== void 0 ? _a : 56,
          height: (_b = data === null || data === void 0 ? void 0 : data.height) !== null && _b !== void 0 ? _b : 56
        }
      })), !!(data === null || data === void 0 ? void 0 : data.profileImageIcon) && _jsx(Avatar, {
        iconName: data === null || data === void 0 ? void 0 : data.profileImageIcon,
        variant: "icon",
        status: data === null || data === void 0 ? void 0 : data.status
      }), !!(data === null || data === void 0 ? void 0 : data.profileName) && !!(data === null || data === void 0 ? void 0 : data.profileClick) && _jsx(View, Object.assign({
        style: TaskWidgetStyles.profileCtaContainer
      }, {
        children: _jsx(TouchableOpacity, Object.assign({
          style: {
            marginLeft: 8
          },
          onPress: () => {
            (data === null || data === void 0 ? void 0 : data.profileClick) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, data === null || data === void 0 ? void 0 : data.profileClick), props));
          }
        }, {
          children: _jsx(Typography, Object.assign({
            type: isSmallScreen ? TEXT_TYPE.BODY_PARA_SM : TEXT_TYPE.BODY_PARA_MD,
            color: BLUE_500,
            text: data === null || data === void 0 ? void 0 : data.profileName
          }, getTestId(testID, 'detailsTaskCardList_descriptionText')))
        }))
      }))]
    }));
  };
  var renderTaskTopCard = singleTaskCardDetails => {
    var _a, _b, _c, _d;
    return _jsxs(View, Object.assign({
      style: TaskWidgetStyles.topCardContainer
    }, {
      children: [_jsxs(View, {
        children: [_jsx(FlatList, {
          data: (_a = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.infoList) !== null && _a !== void 0 ? _a : [],
          horizontal: true,
          keyExtractor: (_, index) => "" + index,
          renderItem: _ref => {
            var item = _ref.item;
            return renderTopInfoTag(item);
          },
          showsHorizontalScrollIndicator: false,
          ItemSeparatorComponent: () => _jsx(View, {
            style: {
              width: tokens.spacing.SPACING_4
            }
          }),
          style: [flatListStyle]
        }), _jsxs(View, Object.assign({
          style: TaskWidgetStyles.topCardTitleText
        }, {
          children: [!!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.taskCardtitleText) && _jsx(View, {
            children: _jsx(Typography, Object.assign({
              text: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.taskCardtitleText,
              isHyperLink: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.isClickableTitleText,
              onPress: event => {
                (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.taskCardtitleTextOnPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.taskCardtitleTextOnPressMetaData), {
                  event
                }), props));
              },
              color: BLACK_900,
              type: isSmallScreen ? TEXT_TYPE.BODY_PARA_SM_BOLD : TEXT_TYPE.BODY_PARA_MD_BOLD
            }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'titleText')))
          }), _jsxs(View, Object.assign({
            style: TaskWidgetStyles.topCardsubTitlecontainer
          }, {
            children: [_jsxs(View, Object.assign({
              style: TaskWidgetStyles.topCardLeftContainer
            }, {
              children: [!!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.leftIconName) && _jsx(DynamicSvg, {
                color: BLACK_900,
                iconName: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.leftIconName
              }), !!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.leftText) && _jsx(View, Object.assign({
                style: TaskWidgetStyles.topCardLeftTextContainer
              }, {
                children: _jsx(Typography, Object.assign({
                  text: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.leftText,
                  isHyperLink: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.isLeftTextClickable,
                  onPress: event => {
                    (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.leftTextOnPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.leftTextOnPressMetaData), {
                      event
                    }), props));
                  },
                  color: BLACK_900,
                  type: isSmallScreen ? TEXT_TYPE.BODY_PARA_SM_BOLD : TEXT_TYPE.BODY_PARA_MD_BOLD
                }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'left_subtitleText')))
              }))]
            })), _jsxs(View, Object.assign({
              style: TaskWidgetStyles.topCardRightContainer
            }, {
              children: [!!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.rightIconName) && _jsx(DynamicSvg, {
                color: BLACK_900,
                iconName: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.rightIconName
              }), !!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.rightText) && _jsx(View, Object.assign({
                style: TaskWidgetStyles.topCardRightTextContainer
              }, {
                children: _jsx(Typography, Object.assign({
                  text: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.rightText,
                  color: BLACK_900,
                  isHyperLink: singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.isRightTextClickable,
                  onPress: event => {
                    (singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.rightTextOnPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.rightTextOnPressMetaData), {
                      event
                    }), props));
                  },
                  type: isSmallScreen ? TEXT_TYPE.BODY_PARA_SM_BOLD : TEXT_TYPE.BODY_PARA_MD_BOLD
                }, getTestId(props === null || props === void 0 ? void 0 : props.testID, 'right_subtitleText')))
              }))]
            }))]
          }))]
        }))]
      }), !!((_b = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.actionIcon) === null || _b === void 0 ? void 0 : _b.iconName) && !!((_c = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.actionIcon) === null || _c === void 0 ? void 0 : _c.onActionPress) && _jsx(View, {
        children: _jsx(Pressable, Object.assign({
          onPress: event => {
            var _a, _b;
            ((_a = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.actionIcon) === null || _a === void 0 ? void 0 : _a.onActionPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign(Object.assign({}, (_b = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.actionIcon) === null || _b === void 0 ? void 0 : _b.onActionPress), {
              event
            }), props));
          }
        }, {
          children: _jsx(DynamicSvg, {
            color: BLACK_900,
            iconName: (_d = singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.actionIcon) === null || _d === void 0 ? void 0 : _d.iconName
          })
        }))
      })]
    }));
  };
  var renderTopRow = (singleTaskCardDetails, index) => {
    return _jsxs(View, Object.assign({
      style: TaskWidgetStyles.topRowContainer
    }, {
      children: [_jsx(HeadingTaskCardTab, Object.assign({
        singleTaskCardDetails: singleTaskCardDetails,
        isMobileScreen: isSmallScreen,
        onUserAction: onUserAction
      }, getTestId(testID + '_detailsTaskCardList', index.toString()))), renderDescriptionRow(singleTaskCardDetails, index)]
    }));
  };
  var renderSingleDetails = (index, singleTaskCardDetails) => {
    var _a, _b;
    var infoItemButtonsWidgetProps = singleTaskCardDetails.infoItemButtonsWidgetProps;
    return _jsxs(View, Object.assign({
      style: [TaskWidgetStyles.singleCardWrapper, style]
    }, {
      children: [renderTaskTopCard(singleTaskCardDetails), renderTopRow(singleTaskCardDetails, index), _jsx(SingleTaskCardField, Object.assign({
        singleCardStyle: singleCardStyle,
        onUserAction: onUserAction,
        index: index,
        singleTaskCardDetails: singleTaskCardDetails,
        isMobileScreen: isSmallScreen
      }, getTestId(testID + ("detailsTaskCardList_" + index.toString() + "_detailsData")))), !!singleTaskCardDetails.calloutWidgetProps && _jsx(View, Object.assign({
        style: TaskWidgetStyles === null || TaskWidgetStyles === void 0 ? void 0 : TaskWidgetStyles.calloutWidgetWrapper
      }, {
        children: _jsx(CalloutWidget, Object.assign({}, singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.calloutWidgetProps, {
          onUserAction: onUserAction
        }, getTestId(testID + ("detailsTaskCardList_" + index.toString() + "_collapsibleProps"))))
      })), !!infoItemButtonsWidgetProps && _jsx(View, Object.assign({
        style: TaskWidgetStyles === null || TaskWidgetStyles === void 0 ? void 0 : TaskWidgetStyles.infoItemButtonWidgetContainer
      }, {
        children: _jsx(ButtonWidget, Object.assign({}, infoItemButtonsWidgetProps, {
          onUserAction: onUserAction,
          leftCta: Object.assign({}, ((_a = infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.leftCta) === null || _a === void 0 ? void 0 : _a.title) && Object.assign(Object.assign({}, getTestId(testID + ("infoItemButtonsWidgetProps_leftCta_" + index.toString()))), infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.leftCta)),
          rightCta: Object.assign({}, ((_b = infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.rightCta) === null || _b === void 0 ? void 0 : _b.title) && Object.assign(Object.assign({}, getTestId(testID + ("infoItemButtonsWidgetProps_rightCta_" + index.toString()))), infoItemButtonsWidgetProps === null || infoItemButtonsWidgetProps === void 0 ? void 0 : infoItemButtonsWidgetProps.rightCta))
        }))
      })), _jsx(View, {
        children: !!(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.profileFooter) && renderProfileContainer(singleTaskCardDetails === null || singleTaskCardDetails === void 0 ? void 0 : singleTaskCardDetails.profileFooter)
      })]
    }));
  };
  var onViewableItemsChanged = useCallback(info => {
    onChildCardImpression(info, setOfVisitedIds, onUserAction, id);
  }, []);
  var renderInfoCardData = () => {
    var _a, _b;
    return _jsxs(View, {
      children: [_jsx(View, Object.assign({}, widgetCtaAccessibilityProps, {
        children: _jsx(FlatList, {
          data: detailsTaskCardList,
          keyboardShouldPersistTaps: "handled",
          renderItem: _ref2 => {
            var index = _ref2.index,
              item = _ref2.item;
            return renderSingleDetails(index, item);
          },
          keyExtractor: (item, index) => {
            var _a;
            return (_a = "" + (item === null || item === void 0 ? void 0 : item.subtitleText) + index) !== null && _a !== void 0 ? _a : '';
          },
          ItemSeparatorComponent: () => _jsx(Divider, {
            color: LILAC_400,
            height: 1
          }),
          onViewableItemsChanged: onViewableItemsChanged,
          scrollEnabled: false,
          numColumns: 1,
          style: [flatListStyle]
        })
      })), _jsx(Divider, {
        color: LILAC_400,
        shadowColor: WHITE,
        height: 2
      }), !!rowButtonsWidgetProps && _jsx(View, Object.assign({
        style: TaskWidgetStyles === null || TaskWidgetStyles === void 0 ? void 0 : TaskWidgetStyles.buttonWidgetContainer
      }, {
        children: _jsx(ButtonWidget, Object.assign({}, rowButtonsWidgetProps, {
          onUserAction: onUserAction,
          leftCta: Object.assign({}, ((_a = rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.leftCta) === null || _a === void 0 ? void 0 : _a.title) && Object.assign({
            testID: testID + '_rowButtonsWidgetProps_leftCta'
          }, rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.leftCta)),
          rightCta: Object.assign({}, ((_b = rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.rightCta) === null || _b === void 0 ? void 0 : _b.title) && Object.assign({
            testID: testID + '_rowButtonsWidgetProps_rightCta'
          }, rowButtonsWidgetProps === null || rowButtonsWidgetProps === void 0 ? void 0 : rowButtonsWidgetProps.rightCta))
        }))
      })), !!profileFooter && _jsxs(Fragment, {
        children: [_jsx(Divider, {
          color: LILAC_400,
          shadowColor: WHITE,
          height: 2
        }), _jsx(View, Object.assign({
          style: TaskWidgetStyles.profileFooterMargin
        }, {
          children: renderProfileContainer(profileFooter)
        }))]
      })]
    });
  };
  return _jsx(_Fragment, {
    children: (detailsTaskCardList === null || detailsTaskCardList === void 0 ? void 0 : detailsTaskCardList.length) > 0 && _jsx(Card, Object.assign({
      backgroundColor: LILAC_200,
      noPadding: true
    }, restProps, getTestId(testID), {
      style: [outerContainerStyle]
    }, {
      children: renderInfoCardData()
    }))
  });
};
TaskCardWidgetComponent.genericRendererKey = 'AirTaskCardWidget';